import { Link, useParams } from 'react-router-dom';
import { useSavedReports } from '../../../data/queries/use-saved-reports';
import { savedReportPath } from './saved-report-route';

/**
 * SAVED REPORTS — the list. M10 / S10-05.
 *
 * **METADATA ONLY.** No PDF is downloaded to draw this screen and no snapshot
 * is fetched; each row is six small columns. **Only completed saves appear** —
 * a reservation that never finished is not history.
 *
 * **NOTHING HERE READS LIVE PROJECT DATA.** Not the Project name, not a
 * Capture, not Settings. A saved report is what it was, and a list that
 * enriched itself from today's truth would be the first step in history
 * drifting.
 */
export function SavedReportsScreen() {
  const { projectId = '' } = useParams();
  const { status, reports, error } = useSavedReports(projectId);

  return (
    <main className="cl-screen">
      <p className="project-home-back">
        <Link className="cl-link" to={`/projects/${projectId}`}>
          ‹ Project
        </Link>
      </p>

      <h1 className="cl-screen-title">Saved reports</h1>

      {status === 'loading' ? (
        <p className="projects-loading" role="status">
          Loading your saved reports…
        </p>
      ) : null}

      {/* A failed read is NOT an empty list. Saying "none" when the answer
          never arrived would tell Brandon his history is gone. */}
      {status === 'failed' ? (
        <p className="cl-error" role="alert">
          {error}
        </p>
      ) : null}

      {status === 'ready' && reports.length === 0 ? (
        <p className="projects-empty-body">
          No saved reports yet. Generate a report, then choose <strong>Save Report</strong> to keep
          it here.
        </p>
      ) : null}

      {status === 'ready' && reports.length > 0 ? (
        <ul className="saved-report-list">
          {reports.map((report) => (
            <li key={report.id}>
              <Link className="saved-report-row" to={savedReportPath(projectId, report.id)}>
                <span className="saved-report-date">{report.report_date}</span>
                <span className="saved-report-name">{report.filename}</span>
                <span className="saved-report-meta">
                  {String(report.page_count)} {report.page_count === 1 ? 'page' : 'pages'}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
    </main>
  );
}
